<h1 class="m-0 p-0 ms-1" *ngIf="generalAppData.logoDownloaded && !forHomePage">
  <!-- style="min-width: 250px" -->
  <a class="text-primary d-flex justify-content-center" routerLink="/">
    <img [src]="imagesrc" [alt]="env.name" />
  </a>
</h1>
<img
  class="d-none d-md-block"
  *ngIf="generalAppData.logoDownloaded && forHomePage"
  [src]="imagesrc"
  [alt]="env.name"
/>
<img
  class="d-block d-md-none"
  *ngIf="generalAppData.logoDownloaded && forHomePage"
  [src]="mobileImagesrc ? mobileImagesrc : imagesrc"
  [alt]="env.name"
/>
